const productName = 'Indoor Smart Camera';
const installationInstructions = {
  intro: {
    currentStep: 'intro',
    includeInstallationSteps: false,
    includePairingProcess: false,
    isLastPage: false,
    nextStep: 'pairingMode',
    nextStepName: 'instructions',
    prevStepName: 'https://return-to-app',
    primaryText: `Congratulations on getting an ${productName}!`,
    haloDeviceResource: require('@/assets/device-models/P159/p159.png'),
    resourceType: 'image',
    secondaryText: 'Let’s get started with pairing your new camera',
    continueButtonText: 'Start pairing',
  },
  pairingMode: {
    currentStep: 'pairingMode',
    lastPageExitUrl: 'https://www.exit-installation-instructions-flow',
    nextStep: 'letsGetStarted',
    prevStepName: 'installationIntro',
    headerOverridingClass: 'background-gray',
    resource: require('@/assets/device-models/P159/p159.png'),
    resourceType: 'image',
    primaryText: 'Power on your camera',
    secondaryText: `After you have assembled your ${productName}, plug it in using the supplied power adapter. The light on the front of your camera will turn on when the camera is on.`,
  },
  letsGetStarted: {
    continueButtonText: 'Ready',
    currentStep: 'letsGetStarted',
    isLastPage: true,
    lastPageExitUrl: 'https://www.exit-installation-instructions-flow',
    primaryActionKey: 'chooseProvider', // Choose Pepper or Tuya FW
    prevStep: 'pairingMode',
    headerOverridingClass: 'background-gray',
    primaryText: 'Verify device is in pairing mode',
    resource: require('@/assets/device-models/P159/p159.png'),
    resourceType: 'image',
    secondaryText: 'It may take a few minutes after powering on the camera before it is in pairing mode. Ways to verify:',
    steps: [
      {
        title: 'Sound confirmation',
        description: 'You will hear a sound from the camera when it is ready to pair.',
        stepNumber: 1
      },
      {
        title: 'Blinking light pattern',
        description: 'The light will also turn to a double blinking green.',
        stepNumber: 2
      },
    ],
    alternateNextStep: {
      nextStep: 'pairingModeReset',
      nextStepName: 'instructions',
      title: 'Read instructions',
    }
  },
  pairingModeReset: {
    prevStep: 'letsGetStarted',
    headerIcon: 'arrowGrey',
    prevStepName: 'instructions',
    currentStep: 'pairingModeReset',
    resourceType: 'image',
    resource: require('@/assets/device-models/P159/p159_reset.png'),
    resourceOverridingClass: 'background-none',
    primaryText: `Putting ${productName} into pairing mode`,
    secondaryText: `If the light on the front of the device is not double blinking green, it is not in pairing mode. To manually put the ${productName} into pairing mode:`,
    steps: [
      {
        title: 'Insert reset pin into pin hole',
        description: 'Insert the reset pin provided in your box into the pin hole on the back of the camera.',
        stepNumber: 1
      },
      {
        title: 'Press and hold',
        description: 'Press and hold the button using the reset pin for approximately 10 seconds. Release the button once you see the light on the front of the camera turn red.',
        stepNumber: 2
      },
      {
        title: 'Voice confirmation',
        description: `After the ${productName} finishes restarting, you will hear a voice confirmation indicating the device is ready to pair. The light on the front of your camera will also turn to a double blinking green.`,
        stepNumber: 3
      },
    ],
    primaryActionKey: 'chooseProvider', // Choose Pepper or Tuya FW
    isLastPage: true,
    lastPageExitUrl: 'https://www.exit-installation-instructions-flow',
  }
};

export default installationInstructions;
